export const Settings = {
	ApiAddress: "https://refsite-calculator.herokuapp.com/",
	//ApiAddress: "http://localhost:443/",
}
